import { getRouter} from '@/api/user'

const app = {
  state: {
    router:[]
  },
  mutations: {
    SET_ROUTER:(state, router) => {
      state.router = router
    },
  },
  actions: {
    Router({ commit, state }){
      return new Promise((resolve, reject) => {
        getRouter().then(res=>{
          if(res.success){
            const data = res.data
            commit('SET_ROUTER',data)
            localStorage.setItem('router',JSON.stringify(data))
          };
          resolve(res)
        }).catch(error=>{
          reject(error)
        });
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js